import { Stack } from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'

import { DataGrid, GridColDef } from '../../../../../components'
import { COLORS, styled } from '../../../../../theme'
import { ListFieldRowDefinition } from '../../definitions'

interface DrawerDataGridProps {
  rows: ListFieldRowDefinition[]
  columns: GridColDef[]
}

export const DrawerDataTable = ({ rows, columns }: DrawerDataGridProps) => {
  const StyledContainer = styled(Box)`
    height: 500px;
    width: 100%;
    min-width: 45vw;
    & .actions {
      color: ${COLORS.text.secondary};
    }
    & .textPrimary {
      color: ${COLORS.text.primary};
    }
  `

  return (
    <StyledContainer>
      <DataGrid
        rows={rows}
        columns={columns}
        slots={{
          noRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              This space is empty for now
            </Stack>
          ),
        }}
        hideFooter
        rowSpacingType="margin"
      />
    </StyledContainer>
  )
}
